// Copyright (c) Hamilton Manufacturing Corp.
import React, { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { generateId } from '../_common/api/utility';
import Icon from '../_common/form/Icon';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';

const I = styled(Icon)`
    transform: rotate(${({ drop }) => drop ? '0deg' : '90deg'});
    transition: all 0.5s;
`

const LocationSelect = styled.div`
    position: absolute;
    position: relative;
    display: flex;
    flex-direction: column;
    font-size: 1.2em;
    min-height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.mobile.contrast};
    background: ${({ theme }) => theme.mobile.tertiary};
    z-index: 10;
    box-shadow: 0px 0px 4px 1px ${({ theme }) => theme.mobile.shadow};
    transform: translateY(-110%);

    animation: dropDown;
    animation-delay: 0.3s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`
const LocationDrop = styled.div`
    top: 100%;
    width: 100%;
    padding-top: ${({ drop }) => drop ? '0.5em' : '0'};
    max-height: ${({ drop }) => drop ? '25vh' : '0'};
    background: ${({ theme }) => theme.mobile.tertiary};

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: all 0.2s;
    overflow: hidden;
    position: absolute;
`
const LocationRow = styled.div`
    height: 2em;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const LocShadow = styled.div`
    position: fixed;
    width 100%;
    opacity: ${({ drop }) => drop ? '1' : '0'};
    height: ${({ drop }) => drop ? '100vh' : '0'};
    background-color: ${({ theme }) => theme.secondary}80;
    transition: all 0.4s;
    overflow: hidden;
    z-index: 5;
`

const LocationDropdown = ({ items, locFilter, setLocFilter, ...props }) => {
    const {
        state: {
            active_user,
            site_config,
        },
        getLocations
    } = useGlobalState();

    const { search } = useLocation();
    const location = new URLSearchParams(search)
    const [loc, setLoc] = useState([]);
    // const [locFilter, setLocFilter] = useState(location.get('location') || 0);
    const [locDrop, setLocDrop] = useState(false);

    const setLocation = () => {
        setLoc(
            site_config.locations.map(e => {
                if (active_user.location) {
                    const user = active_user.location
                    e.distanceFromUser = 68.7075 * Math.sqrt(Math.pow((user.lat - e.latitude), 2) + Math.pow((user.lng - e.longitude), 2))
                }
                return {
                    label: e.city,
                    value: parseInt(e.id)
                }
            })
        )

        if (active_user.forcedLocation) {
            if (site_config.locations.find(e => e.id === active_user.forcedLocation)) {
                // setLocFilter(active_user.forcedLocation)
                return;
            }
        }

        if (active_user.location && !location.get('location')) {
            const distances = site_config.locations.sort((a, b) => a.distanceFromUser - b.distanceFromUser)
            if (distances[0]?.distanceFromUser < 1) setLocFilter(distances[0].id)
        }
    }

    useLayoutEffect(() => {
        if (props.customFilter) {
            setLoc(props.customFilter.options);
            if (props.customFilter.defaultFilter) {
                setLocFilter(props.customFilter.defaultFilter);
            }
            return;
        }

        if (!site_config.locations && !site_config.locations.length) {
            getLocations()
                .then(() => setLocation())
        } else {
            setLocation()
        }
    }, [])

    const customLabel = props.customFilter?.defaultLabel;
    const disableAllFilter = props.customFilter?.disableAllFilter;

    return (
        <div style={{ position: 'relative' }}>
            <LocationSelect onClick={() => setLocDrop(!locDrop)}>
                <div style={{ padding: '1vh', display: 'flex', alignItems: 'center' }}>
                    <span style={{ padding: '0 1em', whiteSpace: 'nowrap' }}>
                        {loc.find(e => e.value === locFilter)?.label || (customLabel || 'All Locations')}
                    </span>
                    <I icon='chevronDown' drop={locDrop ? 1 : 0} />
                </div>
                <LocationDrop drop={locDrop}>
                    {
                        (disableAllFilter ? [...loc] : [{ label: (customLabel || 'All Locations'), value: 0 }, ...loc])
                            .filter(e => e.value !== locFilter)
                            .map(e => <LocationRow key={generateId()} onClick={() => setLocFilter(e.value)}>{e.label}</LocationRow>)
                    }
                </LocationDrop>
            </LocationSelect>
            <LocShadow drop={locDrop} onClick={() => setLocDrop(!locDrop)} />
        </div>
    );
}
export default LocationDropdown;